import { render, staticRenderFns } from "./customer-order-statistic.vue?vue&type=template&id=45253eb6&scoped=true"
import script from "./customer-order-statistic.vue?vue&type=script&lang=ts"
export * from "./customer-order-statistic.vue?vue&type=script&lang=ts"
import style0 from "./customer-order-statistic.vue?vue&type=style&index=0&id=45253eb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45253eb6",
  null
  
)

export default component.exports